module.exports = __webpack_public_path__ + "static/img/协和万邦的由来背景@2x.2269d3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/协和万邦的由来背景@2x.png
// module id = +8Yg
// module chunks = 0